export const BASE_ROUTE = {
  HOLIDAY: '/holiday',
  ATTENDANCE: '/timedoctor',
  TIME_TRACKING: '/time-tracking',
  DEPARTMENT: '/department',
  EMPLOYEES: '/users',
  DESIGNATION: '/designation',
  GET_LEAVE_TYPE: '/leave-type',
  GET_LEAVE_REQUEST: '/leave',
  GET_LEAVE_BALANCE: '/leave-balance',
  GET_EMPLOYEE_REQUEST: '/users',
  UPLOAD_FILES: '/upload',
  FILE_NOTE: '/file-note',
  GET_BALANCE_USER: `/leave-balance/user/list`,
  PAYROLL: '/payroll',
  SUPPORT_TICKET: '/support-ticket',
  COMPLAIN: '/complain',
  CONTACT_US: '/contact-us',
  CONFERENCE_ROOM: '/conference-room',
  ASSETS: '/assets',
  ASSET_FIELDS: '/asset-fields',
  DASHBOARD: '/dashboard',
  CALENDAR: '/calendar',
  KPI: '/kpi',
  PERFORMANCE: '/performance',
  HRX_NOTIFICATION: '/hrx-notification',
  LOP_OVERTIME_REQUEST: '/lop-overtime-request',
  HRX_ATTENDANCE: '/attendance',
  ATTENDANCE_VIOLATION: '/attendance-violation',
  FILEUPLOAD_FILES_S3: '/file'
};

export const USER_AUTH_ROUTE = {
  LOGIN_ROUTE: '/auth/pms-login',
  VERIFY_ROUTE: '/auth/verify-otp',
  IS_LOGIN_ROUTE: '/auth/is-logged-in',
  IS_LOGOUT_ROUTE: '/auth/logout',
  GOOGLE_SSO_ROUTE: '/auth/google'
};

export const PAYROLL_ROUTE = {
  GET_EMPLOYEES_LOP: '/get-employees-lop-overtime',
  CORRECTION_LOP: '/correction-lop-overtime',
  GET_SIX_MONTH_LOP_OVERTIME: '/get-six-month-lop-overtime'
};

const {
  HOLIDAY,
  ATTENDANCE,
  TIME_TRACKING,
  DEPARTMENT,
  EMPLOYEES,
  DESIGNATION,
  GET_LEAVE_TYPE,
  GET_LEAVE_REQUEST,
  GET_EMPLOYEE_REQUEST,
  GET_LEAVE_BALANCE,
  UPLOAD_FILES,
  FILE_NOTE,
  GET_BALANCE_USER,
  ASSETS,
  ASSET_FIELDS,
  DASHBOARD,
  HRX_ATTENDANCE,
  FILEUPLOAD_FILES_S3
} = BASE_ROUTE;

export const HOLIDAY_ROUTE = {
  GET_HOLIDAYS: `${HOLIDAY}`
};

export const ATTENDANCE_ROUTE = {
  GET_ATTENDANCE: `${ATTENDANCE}`
};

export const TIME_TRACKING_ROUTE = {
  GET_TIME_TRACKING: `${TIME_TRACKING}`
};

export const EMPLOYEE_ROUTE = {
  GET_EMPLOYEE: `${EMPLOYEES}`,
  GET_EMPLOYEE_ID_CARD: `${EMPLOYEES}/download-employee-id-card`
};

export const DEPARTMENT_ROUTE = {
  GET_DEPARTMENT: `${DEPARTMENT}`
};

export const DESIGNATION_ROUTE = {
  GET_DESIGNATION: `${DESIGNATION}`
};

export const USER_AUTH = {
  USER_LOGIN: USER_AUTH_ROUTE.LOGIN_ROUTE,
  OTP_VERIFY: USER_AUTH_ROUTE.VERIFY_ROUTE,
  IS_LOGIN: USER_AUTH_ROUTE.IS_LOGIN_ROUTE,
  IS_LOGOUT: USER_AUTH_ROUTE.IS_LOGOUT_ROUTE,
  GOOGLE_SSO: USER_AUTH_ROUTE.GOOGLE_SSO_ROUTE
};

export const LEAVE_TYPE = {
  LEAVE_TYPE_GET: GET_LEAVE_TYPE
};

export const LEAVE_REQUEST = {
  LEAVE_REQUEST_GET: GET_LEAVE_REQUEST,
  LEAVE_REQUEST_COUNT: `${GET_LEAVE_REQUEST}/count`
};

export const LEAVE_BALANCE = {
  LEAVE_BALANCE_REQUEST: GET_LEAVE_BALANCE,
  LEAVE_BALANCE_USER_ALL: GET_BALANCE_USER
};

export const ASSETS_URLS = {
  ASSETS: ASSETS
};

export const ASSET_FIELDS_URLS = {
  ASSET_FIELDS: ASSET_FIELDS
};

export const DASHBOARD_URLS = {
  DASHBOARD: DASHBOARD,
  DASHBOARD_CHART: `${DASHBOARD}/chart`
};

export const EMPLOYEE = {
  GET_EMPLOYEE: GET_EMPLOYEE_REQUEST
};

export const FILE_NOTES = {
  UPLOAD_FILES: UPLOAD_FILES,
  FILE_NOTE: FILE_NOTE,
  FILEUPLOAD_FILES_S3: FILEUPLOAD_FILES_S3
};

export const PAYROLL_URL = {
  GET_EMPLOYEES_LOP: `${PAYROLL_ROUTE.GET_EMPLOYEES_LOP}`,
  UPDATE_LOP_CORRECTION: `${PAYROLL_ROUTE.CORRECTION_LOP}`,
  GET_SIX_MONTH_LOP_OVERTIME: `${PAYROLL_ROUTE.GET_SIX_MONTH_LOP_OVERTIME}`
};

export const SUPPORT_TICKET_REQUEST = {
  GET_SUPPORT_TICKETS: `${BASE_ROUTE.SUPPORT_TICKET}`,
  POST_SUPPORT_TICKET: `${BASE_ROUTE.SUPPORT_TICKET}`,
  DELETE_SUPPORT_TICKET: `${BASE_ROUTE.SUPPORT_TICKET}`,
  PUT_SUPPORT_TICKET: `${BASE_ROUTE.SUPPORT_TICKET}`
};

export const COMPLAIN_REQUEST = {
  GET_COMPLAINS: `${BASE_ROUTE.COMPLAIN}`,
  POST_COMPLAIN: `${BASE_ROUTE.COMPLAIN}`,
  DELETE_COMPLAIN: `${BASE_ROUTE.COMPLAIN}`,
  PUT_COMPLAIN: `${BASE_ROUTE.COMPLAIN}`
};

export const CONFERENCE_ROOM_REQUEST = {
  GET_ROOMS: `${BASE_ROUTE.CONFERENCE_ROOM}`,
  POST_ROOM: `${BASE_ROUTE.CONFERENCE_ROOM}`,
  PUT_ROOM: `${BASE_ROUTE.CONFERENCE_ROOM}`,
  DELETE_ROOM: `${BASE_ROUTE.CONFERENCE_ROOM}`,
  GET_BOOKINGS: `${BASE_ROUTE.CONFERENCE_ROOM}/bookings`,
  POST_BOOKING: `${BASE_ROUTE.CONFERENCE_ROOM}/bookings`,
  DELETE_BOOKING: `${BASE_ROUTE.CONFERENCE_ROOM}/bookings`
};

export const CONTACT_US_REQUEST = {
  GET_CONTACT_US: `${BASE_ROUTE.CONTACT_US}`,
  POST_CONTACT_US: `${BASE_ROUTE.CONTACT_US}`,
  DELETE_CONTACT_US: `${BASE_ROUTE.CONTACT_US}`,
  PUT_CONTACT_US: `${BASE_ROUTE.CONTACT_US}`,
  GET_VISITOR_HOSTS: `${BASE_ROUTE.CONTACT_US}/hosts`
};

export const CALENDAR_URLS = {
  GET_CALENDAR_EVENTS_DATA: `${BASE_ROUTE.CALENDAR}/get-calendar-events`
};

export const KPI_REQUEST = {
  GET_KPI: `${BASE_ROUTE.KPI}`,
  POST_KPI: `${BASE_ROUTE.KPI}`,
  DELETE_KPI: `${BASE_ROUTE.KPI}`,
  PUT_KPI: `${BASE_ROUTE.KPI}`
};

export const PERFORMANCE_REQUEST = {
  GET_PERFORMANCE: `${BASE_ROUTE.PERFORMANCE}`,
  POST_PERFORMANCE: `${BASE_ROUTE.PERFORMANCE}`,
  DELETE_PERFORMANCE: `${BASE_ROUTE.PERFORMANCE}`,
  PUT_PERFORMANCE: `${BASE_ROUTE.PERFORMANCE}`,
  POST_KPI_PERFORMANCE_FILTER: `${BASE_ROUTE.PERFORMANCE}/get-kpi-performance`,
  GET_SIX_MONTH_PERFORMANCE: `${BASE_ROUTE.PERFORMANCE}/get-six-month-performance`
};

export const NOTIFICATION_REQUEST = {
  GET_HRX_NOTIFICATION: `${BASE_ROUTE.HRX_NOTIFICATION}`,
  POST_HRX_NOTIFICATION: `${BASE_ROUTE.HRX_NOTIFICATION}`,
  DELETE_HRX_NOTIFICATION: `${BASE_ROUTE.HRX_NOTIFICATION}`,
  PUT_HRX_NOTIFICATION: `${BASE_ROUTE.HRX_NOTIFICATION}`,
  PUT_NOTIFICATION_STATUS: `${BASE_ROUTE.HRX_NOTIFICATION}/read-status`
};

export const LOP_OVERTIME_REQUEST_URL = {
  GET_LOP_OVERTIME_REQUEST: `${BASE_ROUTE.LOP_OVERTIME_REQUEST}`,
  POST_LOP_OVERTIME_REQUEST: `${BASE_ROUTE.LOP_OVERTIME_REQUEST}`,
  DELETE_LOP_OVERTIME_REQUEST: `${BASE_ROUTE.LOP_OVERTIME_REQUEST}`,
  PUT_LOP_OVERTIME_REQUEST: `${BASE_ROUTE.LOP_OVERTIME_REQUEST}`
};

export const ATTENDANCE_APPROVAL_REQUEST = {
  GET_KPI: `${BASE_ROUTE.ATTENDANCE}`,
  POST_KPI: `${BASE_ROUTE.ATTENDANCE}`,
  DELETE_KPI: `${BASE_ROUTE.ATTENDANCE}`,
  PUT_KPI: `${BASE_ROUTE.ATTENDANCE}`
};

export const HRX_ATTENDANCE_ROUTE = {
  GET_HRX_ATTENDANCE: `${HRX_ATTENDANCE}`,
  ATTENDANCE_TIME_LOG: '/attendance-time-log'
};

export const ATTENDANCE_VIOLATION_ROUTE = {
  MONTHLY_VIOLATIONS: `${BASE_ROUTE.ATTENDANCE_VIOLATION}/monthly`,
  MY_WARNINGS: `${BASE_ROUTE.ATTENDANCE_VIOLATION}/my-warnings`,
  APPLY_LEAVE: `${BASE_ROUTE.ATTENDANCE_VIOLATION}/apply-leave`,
  BULK_DISMISS: `${BASE_ROUTE.ATTENDANCE_VIOLATION}/bulk-dismiss`,
  dismissViolation: (violationId) => `${BASE_ROUTE.ATTENDANCE_VIOLATION}/${violationId}`
};
